module.exports = __webpack_public_path__ + "img/confirmation-number.c6448ed9.svg";